<!-- MODAL seleccionImpuesto -->
<div mdbModal #stockProducto="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4  class="modal-title w-100 text-left" id="myModalLabel">
                    Consulta Stock de Producto
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="stockProducto.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col">
                      <div class="table-responsive">
                        <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientos">
                          <thead>
                            <tr class="grey lighten-2">
                              <th scope="col">Bodega</th>
                              <th scope="col">Cod. Formato</th>
                              <th scope="col">Formato</th>
                              <th scope="col">Saldo</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td colspan="100%" style="text-align: center" *ngIf="loading">
                                <mdb-spinner spinnerColor="blue"></mdb-spinner>
                              </td>
                              <td colspan="100%" style="text-align: center" *ngIf="!loading && listaMovimientos?.length === 0">
                                No se encontró información
                              </td>
                            </tr>
                            <tr *ngFor="let mov of listaMovimientos">
                              <td>{{ mov.bodega_nombre }}</td>
                              <td>{{ mov.formato_codigo }}</td>
                              <td>{{ mov.formato_nombre }}</td>
                              <td>{{ mov.stock_disponible }}</td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr class="grey lighten-2">
                              <th scope="col" colspan="2">Totales</th>
                              <th scope="col"></th>
                              <th scope="col">{{totales.total | numerico}}</th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-sm btn-default waves-light" size="sm" data-dismiss="modal"
                    (click)="stockProducto.hide()" mdbWavesEffect>Cerrar</button>
            </div>
        </div>
    </div>
</div>